"use client";
import { useState, useEffect, useRef } from "react";

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

const SearchBar = ({ onSearch, placeholder = "Search blogs..." }: SearchBarProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const previousQueryRef = useRef("");

  // Auto-search as user types (with debounce)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Only call onSearch if the query actually changed
      if (searchQuery !== previousQueryRef.current) {
        onSearch(searchQuery);
        previousQueryRef.current = searchQuery;
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [searchQuery, onSearch]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };


  return (
    <div className="blog-search-bar">
      <form onSubmit={handleSearch} className="search-form">
        <label htmlFor="search-input" className="search-input-group">
          <button type="submit" className="search-button">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.25 19.25L16.0418 16.0417M18.3333 10.5417C18.3333 14.8449 14.8449 18.3333 10.5417 18.3333C6.23845 18.3333 2.75 14.8449 2.75 10.5417C2.75 6.23845 6.23845 2.75 10.5417 2.75C14.8449 2.75 18.3333 6.23845 18.3333 10.5417Z" stroke="#56595C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={placeholder}
            id="search-input"
            className="search-input"
          />
        </label>
      </form>
    </div>
  );
};

export default SearchBar;
